export default function applyCalFilters(){
    this.setEvents(this, {prefix: "calendar"});
}   